import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface ProjectsKeyType {
  account: LocalesKey;
  add: LocalesKey;
  addTags: LocalesKey;
  addFilesRelatedToTheProjectSuchAsDrawingsTexturesReferencesModelsEtc: LocalesKey;
  areYouSureYouWantToDeleteThisProjectYouWillNotBeAbleToUndoThisAction: LocalesKey;
  attachDirectlyToProject: LocalesKey;
  all: LocalesKey;
  alreadyMember: LocalesKey;
  backToProjectsList: LocalesKey;
  batchOperations: LocalesKey;
  createYourOwnInvoiceAndAddHereAllThePartsOfYourProject: LocalesKey;
  canceledPluralLowerCase: LocalesKey;
  createOnly: LocalesKey;
  doYouAlsoWantToTurnOnNotificationsForAllTasksInThisProject: LocalesKey;
  doYouAlsoWantToTurnOffNotificationsForAllTasksInThisProject: LocalesKey;
  id: LocalesKey;
  list: LocalesKey;
  plural: LocalesKey;
  singular: LocalesKey;
  singularLowerCase: LocalesKey;
  company: LocalesKey;
  create: LocalesKey;
  createNew: LocalesKey;
  current: LocalesKey;
  coefficient: LocalesKey;
  name: LocalesKey;
  description: LocalesKey;
  destination: LocalesKey;
  downloadAllTasksResults: LocalesKey;
  downloadReport: LocalesKey;
  addDescription: LocalesKey;
  addName: LocalesKey;
  editDescription: LocalesKey;
  fortunatelyItsEasyToCreateOne: LocalesKey;
  group: LocalesKey;
  groupLowerCase: LocalesKey;
  createGroup: LocalesKey;
  groupName: LocalesKey;
  moveToGroup: LocalesKey;
  moveToProject: LocalesKey;
  removeFromGroup: LocalesKey;
  ungroup: LocalesKey;
  my: LocalesKey;
  myResults: LocalesKey;
  results: LocalesKey;
  search: LocalesKey;
  searchByProjectName: LocalesKey;
  searchProjectsByNameOrUser: LocalesKey;
  selectSingular: LocalesKey;
  sendInvoice: LocalesKey;
  singularAttachments: LocalesKey;
  start: LocalesKey;
  allAttachments: LocalesKey;
  status: LocalesKey;
  tasks: LocalesKey;
  tasksView: LocalesKey;
  groupsView: LocalesKey;
  looksLikeYouDontHaveAnyProjects: LocalesKey;
  leave: LocalesKey;
  new: LocalesKey;
  noVisibleProjectsFound: LocalesKey;
  notAllowedSubprojectsOnlyWithinSameCompanySelectedProjectsDifferentCompanies: LocalesKey;
  remove_from: LocalesKey;
  setDueDate: LocalesKey;
  tags: LocalesKey;
  view: LocalesKey;
  optionalPleaseProvideARawEstimationOnProjectBudget: LocalesKey;
  optionalWhenYouExpectTheProjectToBeFinished: LocalesKey;
  projectNotificationsAreTurnedOn: LocalesKey;
  projectNotificationsAreTurnedOff: LocalesKey;
  areYouSureYouWantRemoveYouFromProjectThisActionCannotBeUndone: LocalesKey;
  areYouCertainAboutLeavingTheProjectPleaseBeAwareOfTheFollowingOutcomes: LocalesKey;
  team: LocalesKey;
  total: LocalesKey;
  totalCost: LocalesKey;
  trackProjectTime: LocalesKey;
  optional: LocalesKey;
  pleaseProvideTheProjectBriefFilesAndScopeOfWork: LocalesKey;
  projectName: LocalesKey;
  projectTeam: LocalesKey;
  projectMuted: LocalesKey;
  muteProject: LocalesKey;
  muteProjectNotification: LocalesKey;
  unmuteProjectNotification: LocalesKey;
  messages: LocalesKey;
  pleaseEvaluate: LocalesKey;
  pleaseCreateYourFirstProjectToProceed: LocalesKey;
  pluralLowerCase: LocalesKey;
  recent: LocalesKey;
  inviteSelected: LocalesKey;
  inviteUser: LocalesKey;
  inviteToMultipleProjects: LocalesKey;
  invitations: LocalesKey;
  changeEstimateCost: LocalesKey;
  unallocatedFunds: LocalesKey;
  update: LocalesKey;
  url: LocalesKey;
  selectProductsLifestyleScenesOrMaterialsFromOur3DStockToUseInYourProject: LocalesKey;
  youCanCreateYourOwnInvoiceAndAddHereAllThePartsOfYourProject: LocalesKey;
  youCanAddFilesRelatedToTheProjectSuchAsDrawingsTexturesReferencesModelsEtc: LocalesKey;
  youWillNoLongerReceiveNotificationsRelatedToThisProject: LocalesKey;
  theProjectWillBeExcludedFromYourMyProjectsList: LocalesKey;
  itWontBeIncludedInSearchResultsFilteredByYouAsAProjectMember: LocalesKey;
  alsoMuteNotificationsForAllTasksWithinTheProject: LocalesKey;
  alsoUnmuteNotificationsForAllTasksWithinTheProject: LocalesKey;
  refreshStatus: LocalesKey;
}

export const projectsKeys = keyPathMirror<ProjectsKeyType, string>(
  {
    account: null,
    add: null,
    addTags: null,
    addFilesRelatedToTheProjectSuchAsDrawingsTexturesReferencesModelsEtc: null,
    areYouSureYouWantToDeleteThisProjectYouWillNotBeAbleToUndoThisAction: null,
    attachDirectlyToProject: null,
    all: null,
    alreadyMember: null,
    backToProjectsList: null,
    batchOperations: null,
    createYourOwnInvoiceAndAddHereAllThePartsOfYourProject: null,
    canceledPluralLowerCase: null,
    company: null,
    createOnly: null,
    doYouAlsoWantToTurnOnNotificationsForAllTasksInThisProject: null,
    doYouAlsoWantToTurnOffNotificationsForAllTasksInThisProject: null,
    id: null,
    list: null,
    plural: null,
    singular: null,
    singularLowerCase: null,
    status: null,
    create: null,
    createNew: null,
    current: null,
    coefficient: null,
    name: null,
    description: null,
    destination: null,
    downloadAllTasksResults: null,
    downloadReport: null,
    addDescription: null,
    addName: null,
    editDescription: null,
    fortunatelyItsEasyToCreateOne: null,
    group: null,
    groupLowerCase: null,
    createGroup: null,
    groupName: null,
    moveToGroup: null,
    moveToProject: null,
    removeFromGroup: null,
    ungroup: null,
    looksLikeYouDontHaveAnyProjects: null,
    leave: null,
    my: null,
    myResults: null,
    results: null,
    searchByProjectName: null,
    selectSingular: null,
    sendInvoice: null,
    singularAttachments: null,
    start: null,
    allAttachments: null,
    tasks: null,
    tasksView: null,
    groupsView: null,
    new: null,
    noVisibleProjectsFound: null,
    notAllowedSubprojectsOnlyWithinSameCompanySelectedProjectsDifferentCompanies:
      null,
    remove_from: null,
    search: null,
    searchProjectsByNameOrUser: null,
    setDueDate: null,
    tags: null,
    total: null,
    totalCost: null,
    view: null,
    optionalPleaseProvideARawEstimationOnProjectBudget: null,
    optionalWhenYouExpectTheProjectToBeFinished: null,
    areYouSureYouWantRemoveYouFromProjectThisActionCannotBeUndone: null,
    areYouCertainAboutLeavingTheProjectPleaseBeAwareOfTheFollowingOutcomes:
      null,
    team: null,
    trackProjectTime: null,
    optional: null,
    pleaseEvaluate: null,
    pleaseCreateYourFirstProjectToProceed: null,
    pleaseProvideTheProjectBriefFilesAndScopeOfWork: null,
    projectName: null,
    projectTeam: null,
    projectMuted: null,
    projectNotificationsAreTurnedOn: null,
    projectNotificationsAreTurnedOff: null,
    pluralLowerCase: null,
    recent: null,
    muteProject: null,
    muteProjectNotification: null,
    unmuteProjectNotification: null,
    messages: null,
    inviteSelected: null,
    inviteUser: null,
    inviteToMultipleProjects: null,
    invitations: null,
    changeEstimateCost: null,
    unallocatedFunds: null,
    update: null,
    url: null,
    selectProductsLifestyleScenesOrMaterialsFromOur3DStockToUseInYourProject:
      null,
    youCanCreateYourOwnInvoiceAndAddHereAllThePartsOfYourProject: null,
    youCanAddFilesRelatedToTheProjectSuchAsDrawingsTexturesReferencesModelsEtc:
      null,
    youWillNoLongerReceiveNotificationsRelatedToThisProject: null,
    theProjectWillBeExcludedFromYourMyProjectsList: null,
    itWontBeIncludedInSearchResultsFilteredByYouAsAProjectMember: null,
    alsoMuteNotificationsForAllTasksWithinTheProject: null,
    alsoUnmuteNotificationsForAllTasksWithinTheProject: null,
    refreshStatus: null
  },
  'models.projects.'
);
